<template>
    <b-btn
        :size="size"
        :variant="btn_variant"
        :class="{'active': copying_to_clipboard}"
        content="Copy to Clipboard"
        v-tippy="{placement: 'top'}"
        @click="copyToClipboard"
        :disabled="copying_to_clipboard || disabled"
    >
        <span v-if="copying_to_clipboard">
            <font-awesome-icon :icon="['fas', 'check']" fixed-width/>
        </span>
        <span v-else>
            <font-awesome-icon :icon="['fad', 'clipboard']" fixed-width/>
        </span>
    </b-btn>
</template>

<style lang="scss" scoped>

</style>

<script>
import copy from 'copy-html-to-clipboard'
import {strip} from '@/common/questionsExporter/utility'

export default {
    data: () => ({
        copying_to_clipboard: false
    }),
    props: {
        value: [String, Function, Promise],
        asHtml: Boolean,
        size: String,
        variant: String,
        element_id: String,
        disabled: Boolean,
        stripTags: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    computed: {
        btn_variant() {
            if (this.variant) {
                return this.variant
            } else if (this.copying_to_clipboard) {
                return 'success'
            } else {
                return 'light'
            }
        }
    },
    methods: {
        async copyToClipboard() {
            if (this.disabled) {
                return
            }

            this.$emit('clipboard-copy')

            if (this.value) {
                await this.copyText()
            }
            if (this.element_id) {
                this.copyRange()
            }
        },
        async copyText() {
            let value = this.value

            if (value instanceof Function) {
                value = value()
            }
            if (value instanceof Promise) {
                value = await value
            }

            // remove all tags
            if (this.stripTags) {
                value = strip(value)
                copy(value, {
                    asHtml: false,
                })
            } else {
                copy(value, {
                    asHtml: this.asHtml
                })
            }

            this.copying_to_clipboard = true

            setTimeout(() => {
                this.copying_to_clipboard = false
            }, 1500)
        },
        copyRange() {
            var range = document.createRange();
            range.selectNode(document.getElementById(this.element_id));
            window.getSelection().removeAllRanges(); // clear current selection
            window.getSelection().addRange(range); // to select text
            document.execCommand("copy");
            window.getSelection().removeAllRanges(); // to deselect

            this.copying_to_clipboard = true

            setTimeout(() => {
                this.copying_to_clipboard = false
            }, 1500)
        }
    }
}
</script>
